import {
  GET_ALL_SCHEMES_SUCCESS,
  UPDATE_SCHEME_STATUS_SUCCESS,
  DELETE_SCHEME_SUCCESS,
  ADD_SCHEME_SUCCESS,
  CLEAR_ADD_SCHEME,
  UPDATE_SCHEME_SUCCESS,
  GET_USER_SCHEME_SUCCESS,
  GET_SCHEMES_BY_ID_SUCCESS,
  GET_SCHEMES_BY_ID,
  SYNC_UPLOAD_SUCCESS,
  GET_ALL_NEW_SCHEMES_SUCCESS,
  GET_NEW_SCHEMES_BY_ID_SUCCESS,
  GET_NEW_SCHEMES_BY_ID,
  GET_DEEP_LINKS_SUCCESS,
  GET_ALL_APP_IDS_SUCCESS,
} from "../actions/scheme-action-types";
import { arrUniqBy } from "../utilities/utilsFunction";
const initialState = {
  allSchemes: [],
  addSchemeSuccess: false,
  userSchemes: {},
  schemeById: {},
  syncObject: {},
  allNewSchemes: [],
  newSchemeById: {},
  allDeepLinks: {},
  allAppIds: [],
};

export default function schemes(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_SCHEMES_SUCCESS:
      return {
        ...state,
        allSchemes: arrUniqBy([...payload], "docID"),
      };
    case UPDATE_SCHEME_STATUS_SUCCESS:
      return {
        ...state,
        allSchemes: state.allSchemes.reduce((arr, val) => {
          if (val.docID === payload.docId) {
            val.status = payload.status;
          }
          arr.push(val);
          return arr;
        }, []),
      };
    case DELETE_SCHEME_SUCCESS:
      return {
        ...state,
        allSchemes: state.allSchemes.reduce((arr, val) => {
          if (val.docID !== payload) {
            arr.push(val);
          }
          return arr;
        }, []),
      };
    case UPDATE_SCHEME_SUCCESS:
    case ADD_SCHEME_SUCCESS:
      return {
        ...state,
        addSchemeSuccess: true,
      };
    case CLEAR_ADD_SCHEME:
      return {
        ...state,
        addSchemeSuccess: false,
      };
    case GET_USER_SCHEME_SUCCESS:
      return {
        ...state,
        userSchemes: payload,
      };
    case GET_SCHEMES_BY_ID:
      return {
        ...state,
        schemeById: {},
      };
    case GET_SCHEMES_BY_ID_SUCCESS:
      return {
        ...state,
        schemeById: payload,
      };
    case SYNC_UPLOAD_SUCCESS:
      return {
        ...state,
        syncObject: payload,
      };
    case GET_ALL_NEW_SCHEMES_SUCCESS:
      return {
        ...state,
        allNewSchemes: [...payload],
      };
    case GET_NEW_SCHEMES_BY_ID:
      return {
        ...state,
        newSchemeById: {},
      };
    case GET_NEW_SCHEMES_BY_ID_SUCCESS:
      return {
        ...state,
        newSchemeById: payload,
      };
    case GET_DEEP_LINKS_SUCCESS:
      return {
        ...state,
        allDeepLinks: payload,
      };
    case GET_ALL_APP_IDS_SUCCESS:
      return {
        ...state,
        allAppIds: payload,
      };
    default:
      return state;
  }
}
